import { Pipe, PipeTransform } from "@angular/core";
import { isUnspecified } from "./is-unspecified";

@Pipe({
  standalone: false,
  name: "roleDisplay",
})
export class RoleDisplayPipe implements PipeTransform {
  transform(role: string) {
    return isUnspecified(role) ? "" : role;
  }
}
